import type { FunctionComponent } from 'react';
import { Box } from '@rsos/base-components';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import { Row } from '../tableShared/index.styles';
import { ActionButton } from './index.styles';

interface Props {
  customMessage: PreconfiguredResponse;
  handleDeleteModal: (customMessage: PreconfiguredResponse) => void;
  handleManageModal: (customMessage: PreconfiguredResponse) => void;
}

const TableRow: FunctionComponent<Props> = ({
  customMessage,
  handleDeleteModal,
  handleManageModal,
}) => {
  const handleDelete = () => {
    handleDeleteModal(customMessage);
  };
  const handleManage = () => {
    handleManageModal(customMessage);
  };
  return (
    <Row>
      <td>{customMessage.title ?? ''}</td>
      <td>{customMessage.body ?? ''}</td>
      <td>
        <Box horizontal flow={4}>
          <ActionButton onClick={handleManage}>Edit</ActionButton>
          <ActionButton onClick={handleDelete}>Delete</ActionButton>
        </Box>
      </td>
    </Row>
  );
};

export default TableRow;
